import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import {PaymentMethods} from '../../../../../_common/payments2/index';
import {getCurrentPrices, updateOnboardingStep} from '../../../../../actions/facilita-api';
import {getBillingCustomerId, processPayment} from '../../../../../actions/user-api';
import {LoadingState} from '../../../../../_common/loadingState';
import * as R from 'ramda';
import featuresMode from '../../../../../assets/images/placeholder/Features-mode.svg';

export const BilledByPlatform = ({user, isLoading, referent}) => {
    const prices = [{product: "Facilita", basePrice: 260, reduction:0, currentPrice: 260, num: 1}, {product: "Facilita4", basePrice: 64, reduction:0, currentPrice: 64, num:4}]
    const [paymentPrice, setPaymentPrice] = useState({loaded: false, prices: prices, selectedOption: prices[0]  });
    const [processingPayment, setProcessingPayment] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();


    useEffect(() => {
        dispatch(getBillingCustomerId(referent.id)).then(() => {
            getCurrentPrices(user.id)
            .then((prices) => {
                const facilitaPrices = prices.filter(p => p.product === "Facilita" || p.product === "Facilita4");
                if(!R.isEmpty(facilitaPrices)){
                    let sortedFacilitaPrices = R.sortBy(R.prop("product"), facilitaPrices);
                    setPaymentPrice({loaded: true, prices: sortedFacilitaPrices, selectedOption:sortedFacilitaPrices[0]});
                }else{
                    setPaymentPrice({...paymentPrice, loaded: true});
                }
            });
        });        
        
    }, []);

    if(!paymentPrice.loaded || R.isNil(referent)){
        return <LoadingState />;
    }
    
    return (
        <article className="view-calc mt-3 mb-auto pt-3 mt-lg-n3 pt-lg-3">
            <div className="container-fluid">
                <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 alert alert-primary text-center">
                    <h1 className="text-primary font-weight-bolder mt-0 mb-1">Paiement</h1>
                    <p className="h3 mb-0">Résumé du dossier du défunt.</p>
                </header>
            </div>
            <div className="auto-view my-3">
                <div className="container-fluid">
                    <section className="block">
                        <div className="row gx-2">
                            <div className={"col-12 col-lg"}>
                                <div className={(referent.paymentMethods.length > 0 ? "" : " text-center")}>
                                    { referent.paymentMethods.length > 0 ?
                                        ''
                                    :
                                        <img className="img-fluid mx-auto container-md-press mb-4 d-block" src={featuresMode} alt="features overview" />
                                    }
                                    <h3 className="h3 text-secondary font-weight-bolder mt-3 mb-1">Mode de paiement</h3>
                                    <p className="small o-80">Cliquez ci-dessous pour ajouter ou modifier une méthode de paiement</p>
                                    <PaymentMethods user={referent} loadings={isLoading} stripeClientSecret={user.stripeClientSecret} />
                                </div>
                            </div>
                            <div className="col-12 col-lg-auto">
                                <div className="container-lg">
                                    <h3 className="h3 font-weight-bolder mt-3 mb-2">Votre tarif comprend :</h3>
                                    <div className="card border-0">
                                        <div className="card-body">
                                            <div className="block">
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">Création d’un dossier personnalisé</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">Création, copie et adressage</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">Un espace bibliothèque pour déposer des documents accessibles à tous les proches invités</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small">
                                                    <i className="eva eva-checkmark-outline h4 mr-2 text-success"></i>
                                                    <span className="o-80">Un accès à la plateforme pendant 1 an après le décès</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body pb-2 bg-common text-primary">
                                            <div className="d-flex align-items-start justify-content-between">
                                                <p className="h6 font-weight-bolder my-auto">Total TTC</p>
                                                <p className="h2 font-weight-bolder my-auto">{paymentPrice.prices.find(p => p.product === "Facilita").currentPrice.toFixed(2)} €</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card border-0 bg-common text-primary mt-2">
                                        <div className="card-body py-3">
                                            <h5 className="h5 font-weight-bolder mb-3 pb-2 text-uppercase">Vous pouvez mensualiser votre dossier </h5>
                                            <form className="d-flex align-items-start justify-content-between">
                                                <div className="form-inline w-50">
                                                    <select className="form-control form-control-sm w-50 my-auto mr-sm-2 px-2 rounded py-0" id="mois" onChange={(e) => {
                                                        e.preventDefault();
                                                        let option = paymentPrice.prices.find(p => p.product === e.target.value);
                                                        if (option !== null) {
                                                            setPaymentPrice({ ...paymentPrice, selectedOption: option });
                                                        }
                                                    }}
                                                        value={paymentPrice.selectedOption.product}>
                                                        {paymentPrice.prices.map((option, index) => {
                                                                const months = option.product === "Facilita" ? 1 : 4;
                                                                return <option key={index} value={option.product}>{months}</option>;
                                                        })}
                                                    </select>
                                                    {/* <input type="number" className="form-control form-control-sm w-50 my-auto mr-sm-2 px-2 rounded" id="mois" placeholder="3" /> */}
                                                    <label className="h6 font-weight-bolder my-auto text-body" htmlFor="mois">mois</label>
                                                </div>
                                                <p className="h2 font-weight-bolder my-auto">{paymentPrice.selectedOption.currentPrice} €</p>
                                            </form>
                                        </div>
                                    </div>
                                                                                                          
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <footer className="block mt-auto mb-sm text-right w-100">
                <div className="container-fluid flex-row align-items-center">
                    <Link to={`/facilita/${user.id}/onboarding/step3`} className="btn btn-faded px-md-gutter mr-3 ml-auto">Retour</Link>
                    {
                        processingPayment ?
                            <button className="btn btn-info px-md-gutter px-4 loading-btn" disabled={true}>Payer maintenant <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                        :
                            <button className={"btn btn-info px-md-gutter px-4 loading-btn" + (R.isEmpty(referent.paymentMethods) ? " disabled" : "")} disabled={R.isEmpty(referent.paymentMethods)} onClick={() => {
                                setProcessingPayment(true);
                                dispatch(processPayment(user, undefined, paymentPrice.selectedOption.product === "Facilita"? 1 : 4))
                                .then(() => {
                                    dispatch(updateOnboardingStep(user.id, 6)).then(() => {
                                        setProcessingPayment(false);
                                        history.push(`/facilita/${user.id}`)
                                    });
                                })
                            }}>Payer maintenant <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>

                    }
                    
                </div>
            </footer>
        </article>
    )
}